import dateFormat from "dateformat";

export class ClearingUtils {

  public static isOrderId(id: string) {
    return id ? id.startsWith('O-') : false;
  }

  public static isTradeId(id: string) {
    return id ? id.startsWith('T-') : false;
  }


  public static isClearingId(id: string) {
    return id ? id.startsWith('C-') : false;
  }

  public static getYesterdayBusinessDateSt(format: string): Date {
    return dateFormat(this.getYesterdayBusinessDate(), format);
  }

  public static getYesterdayBusinessDate(): Date {
    const yesterday = new Date();
    yesterday.setUTCHours(0, 0, 0);
    yesterday.setUTCMilliseconds(0);
    yesterday.setDate(yesterday.getDate() - 1);
    var day = yesterday.getDay();
    if (day == 0) {
      yesterday.setDate(yesterday.getDate() - 2);
    } else if (day == 6) {
      yesterday.setDate(yesterday.getDate() - 1);
    }
    return yesterday;
  }

  public static getTodayDate(): Date {
    const yesterday = new Date();
    yesterday.setUTCHours(0, 0, 0);
    yesterday.setUTCMilliseconds(0);
    return yesterday;
  }

}
